import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface PolicyNumberCheck {
  locked_from_upload: boolean;
  message: string;
}

const BASE_URL = '/policies';

@Injectable({
  providedIn: 'root'
})
export class ExternalPolicyFillService {
  constructor(private httpClient: HttpClient,
              private fb: FormBuilder) {}

  externalPolicyCheck(number, email) {
    const payload = {
      policy: { number, email }
    };
    return this.httpClient.post(`${BASE_URL}/external/check`, payload);
  }

  prefillForm(form,
              liabilityCoverageControl, contentCoverageControl,
              payload) {
    const carrier = payload && payload.carrier && payload.carrier.id ? payload.carrier : null;
    if (carrier) {
      form.get('out_of_system_carrier_title').setValue({ id: payload.carrier.id, title: payload.carrier.title });
    }
    // const effectiveDate = payload && payload.policy && payload.policy.effective_date ? payload.policy.effective_date : null;
    // if (effectiveDate) {
    //   form.get('effective_date').setValue(effectiveDate, { emitEvent: false });
    // }
    // const expirationDate = payload && payload.policy && payload.policy.expiration_date ? payload.policy.expiration_date : null;
    // if (expirationDate) {
    //   form.get('expiration_date').setValue(expirationDate, { emitEvent: false });
    // }
    this.setPrimaryUser(form, payload);
    this.setSecondaryUsers(form);
    this.setCoverages(liabilityCoverageControl, contentCoverageControl, payload);
  }

  setPrimaryUser(form, payload) {
    const firstUser = payload && payload.users && payload.users[0] ? payload.users[0] : null;
    if (firstUser) {
      if (firstUser.email) {
        form.get('email').patchValue(firstUser.email, { emitEvent: false });
      }
      const profile = firstUser && firstUser.profile ? firstUser.profile : null;
      if (profile && profile.first_name) {
        form.get('first_name').patchValue(profile.first_name, { emitEvent: false });
      }
      if (profile && profile.last_name) {
        form.get('last_name').patchValue(profile.last_name, { emitEvent: false });
      }
      if (profile && profile.middle_name) {
        form.get('middle_name').patchValue(profile.middle_name, { emitEvent: false });
      }
    }
  }

  setSecondaryUsers(form) {
    const users = (form.get('users') as FormArray)
    users.clear();
  }

  setCoverages(liabilityCoverageControl, contentCoverageControl, payload) {
    const coverageRequirements = payload && payload.coverage_requirements ? payload.coverage_requirements : null;
    if (coverageRequirements && coverageRequirements.length > 0) {
      const liability = coverageRequirements.find(item => item.designation === 'liability');
      if (liability && liability.amount) {
        liabilityCoverageControl.setValue(liability.amount);
      }
    }
    const policyCoverages = payload && payload.policy_coverages ? payload.policy_coverages : null;
    if (policyCoverages && policyCoverages.length > 0) {
      const contents = policyCoverages.find(item => item.designation === 'contents');
      if (contents && contents.limit) {
        contentCoverageControl.setValue(contents.limit / 100);
      }
    }
  }

  /**
   * Checks a policy number information
   * @param number
   */
  checkPolicyNumber(number: string): Observable<PolicyNumberCheck | null> {
    number = number.trim();
    if (!number) {
      return of(null);
    }
    return this.httpClient.get(`${BASE_URL}/check-number/${number}`) as Observable<PolicyNumberCheck>;
  }


  /**
   * Checks a policy number to know if user should upload documents
   * @param number
   */
  policyCanBeUploaded(number: string): Observable<boolean> {
    return this.checkPolicyNumber(number).pipe(
      map(check => {
        return check?.locked_from_upload !== true;
      }),
    );
  }
}
